import type { ManagedUser } from '../api'

export type UserSortKey = 'login' | 'full_name' | 'position' | 'permissions' | 'active'

export function compareUsers(a: ManagedUser, b: ManagedUser, key: UserSortKey): number {
	switch (key) {
		case 'login':
			return a.login.localeCompare(b.login, 'ru')
		case 'full_name':
			return (a.full_name ?? '').localeCompare(b.full_name ?? '', 'ru')
		case 'position':
			return (a.position ?? '').localeCompare(b.position ?? '', 'ru')
		case 'permissions':
			return a.permissions.join(',').localeCompare(b.permissions.join(','), 'ru')
		case 'active':
			return Number(a.is_active) - Number(b.is_active)
		default:
			return 0
	}
}
